import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "./styles/HeroContainer.module.scss";
import Button from "../utilities/Button";
import FlatIcon from "../utilities/FlatIcon";
import {SchoolsDropdown} from "./SchoolsDropdown";
import {useHeroTerrace} from "../../hooks/useHeroTerrace";
import {HeroMediaElement} from "./HeroMediaElement";
import LogoAndTitle from "./LogoAndTitle";
import {useStores} from "../../stores/useStores";
import {useTranslateClassName} from "../../hooks/useTranslateClassName";
import {IconButton} from "@radix-ui/themes";


const HeroContainer = observer((props: {
    displayViewHomepageButton: boolean,
    isWelcomePage: boolean,
    secondaryNavHeight: number,
}) => {
    const {organizationStore, userStore, modalStore, styleStore} = useStores();

    const heroBlock = useHeroTerrace();
    const translateClassName = useTranslateClassName();
    const showSchoolsDropdown = heroBlock && !props.isWelcomePage;
    const editHeroButtonClassName = classNames({
        [styles.editHeroButton]: true,
        [styles.editHeroButtonOnWelcomePage]: props.isWelcomePage,
    });

    function openEditHeroModal() {
        modalStore.addModal({
            type: "edit-hero",
            id: "edit-hero",
        })
    }

    const containerClassName = classNames({
        [styles.container]: true,
        [styles.containerTitleOrg]: organizationStore.currentOrganization.id === organizationStore.organization.id,
        [styles.containerIsWelcomePage]: props.isWelcomePage,
        [styles.containerFloatingBlocksTheme]: styleStore.themeID === "2",
    });

    return (
        <div className={translateClassName}>
            <div className={containerClassName} id={"hero"} style={{height: props.isWelcomePage?  '100vh' : undefined}}>
                <HeroMediaElement isWelcomePage={props.isWelcomePage}/>
                <LogoAndTitle displayViewHomepageButton={props.displayViewHomepageButton}
                              isWelcomePage={props.isWelcomePage}
                              logoClassName={styles.logo}
                              titleClassName={styles.title}
                              />
                {userStore.isEditor &&
                    <IconButton highContrast radius="full" className={editHeroButtonClassName} onClick={openEditHeroModal}
                            aria-label={"Edit Hero Image"}
                            tabIndex={3}>
                        <FlatIcon name={"flaticon-edit-1"}/>
                    </IconButton>}
                {showSchoolsDropdown &&
                    <div className={styles.desktopDropDownContainer}>
                        <SchoolsDropdown heroBlock={heroBlock} />
                    </div>
                }
            </div>
            {showSchoolsDropdown &&
                <div className={styles.mobileDropDownContainer}>
                    <SchoolsDropdown heroBlock={heroBlock} />
                </div>
            }
        </div>
    );
})

export default HeroContainer;
